import React, {useEffect, useState} from "react";

import {LocalizationProvider, MobileDatePicker} from "@mui/x-date-pickers";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns"
import ruLocale from 'date-fns/locale/ru';
import kkLocale from 'date-fns/locale/kk';
import {Divider, Grid, TextField, TextFieldProps, Typography} from "@mui/material";
import {Field, FieldProps, Formik, FormikProps, useFormik} from "formik";
import {initialValues, DatesValidationSchema} from "./formik";
import {useSelector} from "react-redux";
import {State} from "../../../../../redux/store";
import {NewPlanItemDatesForm} from "../../../../../types/newPlanItem";
import {AuctionType} from "../../../../../utils/enums";
import {useTranslation} from "react-i18next";

export const DatesFields = ({
                                formikRef, editingInitialState, disable = false,
                            }: {
    formikRef: React.RefObject<FormikProps<NewPlanItemDatesForm>>;
    editingInitialState?: NewPlanItemDatesForm, disable?: boolean,
}) => {
    const {t} = useTranslation();
    const onSubmit = () => {
    };
    const state = useSelector((state: State) => state);
    const currentTime: string | null = state.public.currentTime;
    const currentDate = currentTime ? new Date(currentTime) : new Date();

    return (
        <Formik innerRef={formikRef}
                initialValues={editingInitialState || initialValues}
                validationSchema={DatesValidationSchema(currentDate)
                }
                onSubmit={onSubmit}
                validateOnMount
        >
            {(frops: FormikProps<NewPlanItemDatesForm>) => (
                <Component
                    frops={frops}
                    currentDate={currentDate}
                    disabled={disable}
                />
            )}
        </Formik>
    )
}

function Component({frops, currentDate, disabled}: {
    frops: FormikProps<NewPlanItemDatesForm>;
    currentDate: Date,
    disabled?: boolean,
}) {
    const {t, i18n} = useTranslation();

    return (
        <LocalizationProvider
            dateAdapter={AdapterDateFns}
            adapterLocale={i18n.language == "kk" ? kkLocale : ruLocale}>
            <Grid container columnSpacing={3} rowSpacing={1}>

                <Grid item container columnSpacing={3} rowSpacing={1}>
                    <Grid item xs={12} sm={6} md={4}>
                        <MobileDatePicker
                            disabled={!currentDate || disabled}
                            minDate={currentDate
                                ? new Date(currentDate)
                                : new Date()}
                            value={frops.values.auctionDate}
                            onChange={(newValue: any) => {
                                frops.setFieldValue("auctionDate", newValue)
                            }}
                            inputFormat="dd/MM/yyyy"
                            label={t("auction.dates.choose_date_and_time")}
                            componentsProps={{
                                actionBar: {
                                    actions: ['today', 'accept', 'cancel'],
                                },
                            }}
                            renderInput={(params: JSX.IntrinsicAttributes & TextFieldProps) => (
                                <Field name={"auctionDate"}>
                                    {({field, form, meta}: FieldProps) => (
                                        <TextField {...params} fullWidth size="small" color="primary"
                                                   label={t("cabinet.new_plan_item.fields.dates.auction_date")}
                                                   error={!!(meta.touched && meta.error)}
                                                   helperText={meta.touched && meta.error}
                                                   InputLabelProps={{shrink: !!field.value}}
                                        />
                                    )}
                                </Field>
                            )}
                        />

                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <MobileDatePicker
                            disabled={disabled}
                            minDate={currentDate}
                            value={frops.values.deliveryDate}
                            onChange={(newValue: any) => frops.setFieldValue("deliveryDate", newValue)}
                            inputFormat="dd/MM/yyyy"
                            renderInput={(params: JSX.IntrinsicAttributes & TextFieldProps) => (
                                <Field name={"deliveryDate"}>
                                    {({field, form, meta}: FieldProps) => (
                                        <TextField {...params} fullWidth size="small" color="primary"
                                                   label={t("cabinet.new_plan_item.fields.dates.delivery_date")}
                                                   error={!!(meta.touched && meta.error)}
                                                   helperText={meta.touched && meta.error}
                                                   InputLabelProps={{shrink: !!field.value}}
                                        />
                                    )}
                                </Field>
                            )}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </LocalizationProvider>
    )
}
